import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate, useLocation } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import moment from "moment";
import Select from "react-select";
import PubSub from "pubsub-js";
import Main from "../layout/Main";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";

const SupplierEdit = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [supplierData, setsupplierData] = useState(location.state ? location.state : {});

 
  //eslint-disable-next-line

  //eslint-disable-next-line
  const [isMultiEnabled, setIsMultiEnabled] = useState(!location.state);

   
  // const handleCourses = (selectedCourses) => {
  //   setSelectedCourses(selectedCourses);
    
  // };
  
  const handleChange = (e) => {

    setsupplierData({...supplierData,[e.target.name]: e.target.value ,});

  };
  
  const checkRequiredFields = () => {
    if (supplierData.name && supplierData.person_name) {
      return false;
    }
    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
   

    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }
    let result2 = {};

    if (supplierData.id) {
      result2 = await trasportApi.saveSupplier(supplierData);
      if (result2.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Updated successfully' });
        navigate(`/suppliers/${supplierData.id}`, { state: supplierData });
      }
    } else {
      console.log("Create Time Item =>",supplierData)
      result2 = await trasportApi.createSupplier(supplierData);
      if (result2?.id) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record saved successfully' });
        navigate(`/suppliers/${supplierData.id}`, { state: result2 });
      } else {
        PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record ERROR', message: result2.errors[0].msg });
      }
    }

  };

  const handleCancel = () => {
    if (location.state?.id) {
      navigate("/suppliers/" + supplierData.id, {state: supplierData,});
    } else {
      navigate("/suppliers/");
    }
  };



  return (
    <Main>
      <>
        <Helmet>
        <title>{LIST_TAB_TITLE.SupplierListEdit}</title>
        </Helmet>
      </>
      <Container className="view-form">
        <Row>
          <Col></Col>
          <Col lg={8}>
            <Form
              className="mt-3"
              onSubmit={handleSubmit}
              noValidate
              validated={validated}
            >
              <Row className="view-form-header align-items-center">
                <Col lg={3}>Edit Supplier Master</Col>
                <Col lg={9} className="d-flex justify-content-end">
                  <Button className="btn-sm mx-2" onClick={handleSubmit}>
                    Save
                  </Button>
                  <Button
                    className="btn-sm"
                    variant="danger"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                       Supplier Name
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="name"
                      placeholder="Supplier Name"
                      value={supplierData.name}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Phone
                    </Form.Label>
                    <Form.Control
                      required
                      type="number"
                      name="phone"
                      placeholder="Enter Your Phone"
                      value={supplierData.phone}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Email
                    </Form.Label>
                    <Form.Control
                      required
                      type="email"
                      name="email"
                      placeholder="Enter Your Email"
                      value={supplierData.email}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Address
                    </Form.Label>
                    <Form.Control
                      required
                      //type="textarea"
                      as="textarea"
                      name="address"
                      placeholder="Enter Your Address"
                      value={supplierData.address}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      City
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="city"
                      placeholder="Enter Your City"
                      value={supplierData.city}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>    
              </Row>
              <Container className="view-form mt-4">
              <Row className="view-form-header align-items-center">
                <Col lg={3}>Edit Contact Person</Col>
              </Row>
              </Container>
              <Row>
              <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Person Name
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="person_name"
                      placeholder="Enter Person name"
                      value={supplierData.person_name}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Pserson Email
                    </Form.Label>
                    <Form.Control
                      required
                      type="email"
                      name="person_email"
                      placeholder="Enter Person Email"
                      value={supplierData.person_email}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Person Number
                    </Form.Label>
                    <Form.Control
                      required
                      type="number"
                      name="person_phone"
                      placeholder="Enter Person Number"
                      value={supplierData.person_phone}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Person Department
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="person_department"
                      placeholder="Enter Person Department"
                      value={supplierData.person_department}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Person Designation
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="person_designation"
                      placeholder="Enter Person Designation"
                      value={supplierData.person_designation}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row></Row>
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </Main>
  );
};
export default SupplierEdit;
